<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم والبحث (تختفي عند الطباعة) -->
    <div class="card shadow-sm mb-4 no-print">
      <div class="card-header bg-primary text-white d-flex align-items-center">
        <h5 class="mb-0">
          <i class="fas fa-search ms-2"></i> طباعة كشوف رصد الأنشطة
        </h5>
      </div>

      <div class="card-body">
        <div class="row align-items-end g-3">
          
          <!-- حقل البحث -->
          <!-- <div class="col-md-4">
            <label class="form-label fw-bold">كود البحث</label>
            <input 
              v-model="form.id" 
              @keypress.enter="GetDataStudentBySchools" 
              class="form-control" 
              type="text" 
              placeholder="أدخل الكود واضغط Enter"
            />
          </div> -->

          <!-- نوع البحث -->
          <!-- <div class="col-md-4 text-center">
            <label class="form-label fw-bold d-block">نطاق البحث</label>
            <div class="btn-group w-100" role="group">
              <input type="radio" class="btn-check" name="searchType" id="search_mange" value="mange_id" v-model="form.search" autocomplete="off">
              <label class="btn btn-outline-primary" for="search_mange">إدارة</label>

              <input type="radio" class="btn-check" name="searchType" id="search_school" value="school_id" v-model="form.search" autocomplete="off">
              <label class="btn btn-outline-primary" for="search_school">مدرسة</label>
            </div>
          </div> -->

          <!-- نظام الطالب -->
          <!-- <div class="col-md-4 text-center">
            <label class="form-label fw-bold d-block">نوع القيد</label>
            <div class="btn-group w-100" role="group">
              <input type="radio" class="btn-check" name="studentSystem" id="sys_regular" value="1" v-model="form.system" autocomplete="off">
              <label class="btn btn-outline-success" for="sys_regular">نظامي</label>

              <input type="radio" class="btn-check" name="studentSystem" id="sys_homes" value="2" v-model="form.system" autocomplete="off">
              <label class="btn btn-outline-success" for="sys_homes">منازل</label>
            </div>
          </div> -->
 <div class="col-md-3 d-flex align-items-end">
    
          </div>
          <!-- زر الطباعة -->
          <div class="col-12 mt-4 text-start border-top pt-3">

                    <button 
              @click="GetDataStudentBySchools" 
              class="btn btn-success mx-2" 
              :disabled="loading || isSaving"
            >
              <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
              <span v-else><i class="fas fa-search ms-1"></i> عرض الطلاب</span>
            </button>

            <button @click="print" class="btn btn-dark px-4">
              <i class="fas fa-print ms-2"></i> طباعة الكشوف
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- 2. منطقة التقرير (الكشوف) -->
 <div v-if="studentss.length > 0" class="print-area">
    
    <!-- حاوية الصفحة -->
    <div class="sheet-page mb-5" id="printMe"> 
      
      <table class="table table-bordered border-dark align-middle text-center grades-table mb-0">
        
        <!-- ======================================================== -->
        <!-- (1) رأس الجدول: هذا الجزء سيتكرر في كل صفحة عند الطباعة -->
        <!-- ======================================================== -->
        <thead>
          
          <!-- الصف الأول: الترويسة الرسمية (بيانات الوزارة والمدرسة) -->
          <!-- نلغي الحدود لهذا الصف لكي يبدو كأنه منفصل -->
          <tr class="header-row border-0">
            <td colspan="7" class="border-0 p-0">
              
              <div class="header-content pb-2">
                <!-- الجزء العلوي: الوزارة والمديرية -->
                <div class="row align-items-center text-center g-3 mb-3 pt-2">
                  <div class="col-3 text-start">
                    <div class="header-text fs-6">
                      <p class="mb-0 fw-bold">محافظة شمال سيناء</p>
                      <p class="mb-0 fw-bold">مديرية التربية والتعليم</p>
                      <p class="mb-0 fw-bold">لجنة النظام والمراقبة</p>
                    </div>
                  </div>

                  <div class="col-6">
                    <h3 class="fw-bold text-decoration-underline mb-2 fs-4">كشــــف رصد درجات</h3>
                    <div class="fw-bold border border-dark p-2 d-inline-block bg-light rounded text-wrap">
                      نشاط (1) - نشاط (2) - التربية الرياضية
                    </div>
                  </div>

                  <div class="col-3 text-center">
                    <div class="header-text fs-6">
                      <p class="mb-0 fw-bold">الفصل الدراسي الأول</p>
                      <h4 class="mb-0 fw-bold mt-1">2025</h4>
                    </div>
                  </div>
                </div>

                <!-- شريط بيانات المدرسة -->
                <div class="school-info border-top border-bottom border-2 border-dark py-2 mb-1">
                  <div class="row g-0 px-2">
                    <div class="col-12 text-md-start">
                      <span class="fw-bold fs-5 ms-2">اسم المدرسة:</span>
                      <span class="fw-bold fs-5">{{ getSchoolName(studentss) }}</span>
                      
                      <span class="float-end fw-bold fs-5">
                        كود: <span class="border border-dark px-2 ms-1 bg-white">{{ getSchoolId(studentss) }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </td>
          </tr>

          <!-- الصف الثاني والثالث: عناوين الأعمدة (تتكرر أيضاً) -->
          <tr class="bg-light">
            <th rowspan="2" style="min-width: 80px;">جلوس</th>
            <th rowspan="2" style="min-width: 200px;">اسم الطالب</th>
            <th colspan="2">نشاط (1)</th>
            <th colspan="2">نشاط (2)</th>
            <th rowspan="2">تربية رياضية (20)</th>
          </tr>
          <tr class="bg-light sub-header">
            <th>الدرجة(10)</th>
            <th class="d-none d-print-table-cell d-md-table-cell text-muted small">مادة النشاط</th>
            <th>الدرجة(10)</th>
            <th class="d-none d-print-table-cell d-md-table-cell text-muted small">مادة النشاط</th>
          </tr>
        </thead>

        <!-- ======================================================== -->
        <!-- (2) جسم الجدول: بيانات الطلاب -->
        <!-- ======================================================== -->
        <tbody>
          <tr v-for="(student, index) in studentss" :key="index">
            <td class="fw-bold fs-5 font-monospace">{{ student.Seating_No }}</td>
            
        <td class="text-end pe-2 fs-6">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
              <span class="fw-bold text-nowrap">{{ student.Arabic_Name | truncate(25) }}</span>
              <div class="mt-1 mt-md-0">
                <span v-if="student.Damg_Status === 'نعم'" class="badge bg-warning text-dark border border-dark small-badge">دمج</span>
                <span v-else-if="student.Stud_Type_Id === 2" class="badge bg-secondary small-badge">منازل</span>
                <span v-else class="badge bg-light text-dark border small-badge">نظامي</span>
              </div>
            </div>
          </td>

            <!-- خانات الكتابة -->
            <td class="write-area">{{ student.activity_1 }}</td> 
            <td class="text-muted small d-none d-print-table-cell d-md-table-cell">(فني/موسيقي)</td>
            
            <td class="write-area">{{ student.activity_2 }}</td>
          <td class="text-muted small d-none d-print-table-cell d-md-table-cell">(صناعي/زراعي)</td>
            
            <td class="write-area">{{ student.sports }}</td>
          </tr>
        </tbody>
      </table>

      <!-- 3. التذييل (يظهر مرة واحدة في نهاية الكشف) -->
      <div class="footer-section mt-4 px-3 page-break-inside-avoid">
        <div class="row text-center gy-4">
          <div class="col-6 text-end">
            <h5 class="fw-bold">لجنة الرصد: ................................</h5>
          </div>
          <div class="col-6 text-start ps-5">
            <h5 class="fw-bold">مدير المدرسة</h5>
            <p class="mt-4">................................</p>
          </div>
        </div>
      </div>

      <!-- فاصل صفحات -->
      <div class="page-break"></div>

    </div>
</div>
  </div>
</template>

<script>
import api from '@/api/axios';
export default {
  name: "ActivityGradesSheet",
  data() {
    return {
      loading: false,
       isSaving: false,
      form: {
        id: "",
        search: "school_id", // القيمة الافتراضية
        system: "1",         // القيمة الافتراضية
      },
      studentss: [], // مصفوفة البيانات الرئيسية
    };
  },
          filters: {
    truncate(value, limit) {
        if (!value) return '';
        if (value.length <= limit) return value;
        return value.substring(0, limit) + '...';
    }
},
mounted() {
  // this.GetDataStudentBySchools()
},
  methods: {
    // دالة محاكاة لجلب البيانات (استبدلها بالـ API الخاص بك)
   async GetDataStudentBySchools() {
      // هنا تضع كود الـ axios لجلب البيانات
   
    //   if (!this.filters.group_id) return alert('الرجاء اختيار المجموعة');
      
      this.loading = true;

      this.students = [];

      try {
        // مثال API:
        const res = await api.get('/getStudentWithSchool');
        // عند استلام البيانات، يجب إضافة خاصية is_changed: false لكل طالب
        this.studentss = res.data['students'];


            this.loading = false;


      } catch (error) {
        console.error(error);
        alert('حدث خطأ أثناء جلب الطلاب');
        this.loading = false;
      }
 
      
      // بيانات وهمية للتجربة (تحاكي الهيكل المعقد لديك)
     
         
    },

    // دوال مساعدة لاستخراج اسم المدرسة بأمان من الهيكل المعقد
    getSchoolName(batch) {
        // console.log(batch[1].School_Name);
        
        try {
            if (batch[1]) return batch[1].School_Name;
            // if (batch[1] && batch[1].length > 0) return batch[1].School_Name;

            return "---";
        } catch (e) { return ""; }
    },
    getSchoolId(batch) {
        // console.log(batch[1].school_id);
        try {
            if (batch[1] ) return batch[1].school_id;
            
            return "";
        } catch (e) { return ""; }
    },


   print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },

  }
};
</script>

<style scoped>
/* تنسيقات عامة للموبايل أولاً */
.fs-20 { font-size: 1rem; }
.fh-23 { font-size: 1.2rem; }
.small-badge { font-size: 0.7rem; }

/* منطقة الكتابة في الجدول */
.write-area {
    background-color: #fff;
    height: 40px;
}

/* في الشاشات الأكبر */
@media (min-width: 768px) {
    .fs-20 { font-size: 1.25rem; }
    .fh-23 { font-size: 1.5rem; }
}

/* === تنسيقات الطباعة الصارمة === */
@media print {
    @page {
        size: A4 landscape; /* يفضل Landscape لكشوف الرصد العريضة */
        margin: 10mm;
    }

    body * {
        visibility: hidden;
    }

    /* إظهار منطقة الطباعة */
    .print-area, .print-area * {
        visibility: visible;
    }

    .print-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        margin: 0;
        padding: 0;
    }

    /* إجبار التخطيط على الشكل الرسمي (3 أعمدة للترويسة) */
    .col-md-3 { width: 25% !important; float: right; text-align: right !important; }
    .col-md-6 { width: 50% !important; float: right; }
    .col-md-4 { width: 33.33% !important; float: right; }
    .col-md-2 { width: 16.66% !important; float: right; }
    .col-md-10 { width: 83.33% !important; float: right; }

    /* إظهار العناصر المخفية في الموبايل */
    .d-print-table-cell { display: table-cell !important; }
    .d-none { display: none !important; } /* إخفاء ما يجب إخفاؤه */

    /* تنسيق الجدول */
    .grades-table th, .grades-table td {
        border: 1px solid #000 !important;
        font-size: 14pt !important;
        padding: 5px !important;
    }

    /* ضمان ظهور الخلفيات */
    .bg-light, .badge {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* فاصل الصفحات */
    .page-break {
        page-break-after: always;
        display: block;
        height: 0;
    }
    
    .sheet-page {
        page-break-inside: avoid;
    }
}
</style>